<template>
    <div class="messageList">
        <message-box v-for="message in messageList" :key='message' :initText="message"></message-box>
        <div  >
        </div>
    </div>
</template>
<script>
import messageBox from '@/components/messageBox'
export default {
    name:'gloabl-message',
    components:{
        'message-box':messageBox
    },
    computed:{
        messageList(){
            return this.$store.state.messageList;
        }
    }
}
</script>
<style lang="scss" scoped>
    .messageList{
        position:absolute;
        top:0;
        right:0;
        margin:4rem;
        display:flex;
        flex-direction:column;
        align-items:flex-end;
    }

</style>